<template>
	<article class="review-report-page">
		<PageHeader />
		<ManagingSection header="신고 정보" :column-count="2">
			<ManagingBox title="문의번호">{{ idReport }}</ManagingBox>
			<ManagingBox title="접수일">{{
				report.parsedCreatedAt
			}}</ManagingBox>
		</ManagingSection>
		<ManagingSection :splice="true">
			<ManagingBox title="문의자">
				<router-link
					class="link"
					:to="`/register/register-info/${report.reporterIdRegister}`"
					target="_blank"
					>{{ report.reporterNickName }}</router-link
				>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection :column-count="2" :splice="true">
			<ManagingBox title="신고사유">{{
				report.reportReason
			}}</ManagingBox>
			<ManagingBox title="IP주소">{{ report.ipAddress }}</ManagingBox>
		</ManagingSection>
		<ManagingSection :splice="true">
			<ManagingBox title="신고내용">
				<div v-if="report.contents" v-html="report.contents"></div>
				<p class="disabled-text" v-else>등록된 내용이 없습니다.</p>
			</ManagingBox>
			<ManagingBox title="신고한 리뷰">
				<div v-html="report.reviewText || '-'"></div>
			</ManagingBox>
			<ManagingBox v-if="report.writerIdRegister" title="리뷰 작성자">
				<router-link
					:to="`/register/register-info/${report.writerIdRegister}`"
					class="link"
					>{{ report.writerNickName }}</router-link
				>
			</ManagingBox>
			<ManagingBox
				v-if="report.writerIdRegister"
				:horizontalMode="true"
				title="리뷰 제품"
			>
				<a
					:href="`${$store.state.env.adminDomain}/brand/${report.idBrand}`"
					class="link"
					v-text="`[${report.name}]`"
				/>
				<router-link
					:to="`/product/product-inquiry/${report.idProduct}`"
					class="link review-report-page__product-name"
					>{{ report.productTitle }}</router-link
				>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection
			header="신고 처리"
			:warning-sub-header="true"
			:sub-header="
				isDeletedReview ? '※ 리뷰가 삭제된 신고 건 입니다' : ''
			"
		>
			<ManagingBox title="처리 상태" :horizontalMode="true">
				{{ reportStateName }}
				<button
					v-if="isDeletedReview && report.reportReviewState !== 'F'"
					class="btn blue review-report-page__done-button"
					v-text="'완료 처리'"
					@click="toF"
				/>
			</ManagingBox>
			<ManagingBox v-if="!isDeletedReview" title="리뷰 상태">
				<RadioList
					v-model="reviewState"
					value-name="name"
					:radio-list="reviewStateList"
					:disabled="true"
					:disabled-ids="['C']"
				/>
			</ManagingBox>
			<ManagingBox
				v-if="reviewState === 'B'"
				title="처리 답변"
				:horizontal-mode="true"
			>
				<select class="select review-report__cause--0" v-model="cause0">
					<option
						v-for="item in causeList"
						:key="item.value"
						:value="item.value"
					>
						{{ item.name }}
					</option>
				</select>
				<select class="select" v-model="cause1" :disabled="!cause0">
					<option
						v-for="item in causeList"
						:key="item.value"
						:value="item.value"
					>
						{{ item.name }}
					</option>
				</select>
			</ManagingBox>
			<ManagingBox
				v-else-if="reviewState === 'C' && blindedCauseList.length"
				title="처리 답변"
				:horizontal-mode="true"
			>
				{{ blindedCauseList.map(item => item.cause).join(' | ') }}
			</ManagingBox>
			<ManagingBox
				v-if="!isDeletedReview"
				title="신고 횟수"
				:horizontal-mode="true"
			>
				{{ report.reportCount }}건
				<span class="review-report__desc"
					>※ 동일한 리뷰 신고는 일괄처리 됩니다.</span
				>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main" @click="initData">초기화</button>
			<button
				class="btn-main blue"
				:disabled="disabledRegisterBtn"
				@click="registerReport"
			>
				등록
			</button>
		</div>
		<ManagingSection>
			<ManagingBox title="메모">
				<MemoBox
					v-if="idReport"
					ref-type="report_reviews"
					:ref-id="idReport"
				/>
			</ManagingBox>
		</ManagingSection>
	</article>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import MemoBox from '@/components/MemoBox.vue';

	export default {
		name: 'ReviewReport',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			RadioList,
			MemoBox,
		},
		data() {
			return {
				idReport: null,
				reviewState: null,
				reviewStateOrigin: null,
				cause0: null,
				cause1: null,
				cause0Origin: null,
				cause1Origin: null,
				report: {},
				blindedCauseList: [],
			};
		},
		computed: {
			...mapState({
				reviewStateList: state => state.filter.reviewCommentStateList, // 리뷰 상태
			}),
			...mapGetters({
				causeList: 'notice/causeList',
				getItemById: 'getItemById',
			}),
			reportStateName() {
				const id = this.report.reportReviewState;
				return id
					? this.getItemById('reportReviewState', id).name
					: '-';
			},
			disabledRegisterBtn() {
				return (
					!this.report.isReviewComment ||
					this.reviewState === 'C' ||
					(this.reviewState === 'B' && !this.cause0)
				);
			},
			isDeletedReview() {
				return (
					this.report &&
					this.report.hasOwnProperty('isReviewComment') &&
					!this.report.isReviewComment
				);
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			historyBack() {
				if (document.referrer.indexOf('/review/report/list') > -1) {
					this.$router.go(-1);
				} else {
					this.$router.push('/review/report/list');
				}
			},
			initData() {
				if (!confirm('답변 내용을 전체 초기화 하시겠어요?')) return;
				this.reviewState = this.reviewStateOrigin;
				this.cause0 = this.cause0Origin;
				this.cause1 = this.cause1Origin;
			},
			async registerReport() {
				const params = {
					id: this.idReport,
					reportReviewState: 'F',
					reviewCommentState: this.reviewState,
					idReviewComment: this.report.idReviewComment,
				};
				if (this.reviewState === 'B' && this.cause0) {
					params.causeIds = [this.cause0];
					if (this.cause1) {
						params.causeIds.push(this.cause1);
					}
				}
				await this.$axiosAdmin2.post('/v3/api/review/report', params);
				this.historyBack();
			},
			async init() {
				if (!this.reasonList) {
					await this.$store.dispatch('notice/init');
				}
				const id = (this.idReport = Number(
					this.$route.params.idReport
				));
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/review/report/${id}`
				);
				const detail = data.blindedReview;
				this.report = {
					...detail,
					reviewText: detail.reviewText
						? detail.reviewText.replace(/(?:\r\n|\r|\n)/g, '<br>')
						: '-',
					parsedCreatedAt: moment(detail.createdAt).format(
						'YYYY.MM.DD HH:mm:SS'
					),
				};
				this.reviewState = this.reviewStateOrigin =
					detail.reviewCommentState;
				this.blindedCauseList = data.blindedCauseList || [];
				this.blindedCauseList.forEach((item, idx) => {
					this[`cause${idx}`] = this[`cause${idx}Origin`] = item.id;
				});
			},
			async toF() {
				try {
					if (!confirm('정말 완료처리하시겠습니까?')) return;
					await this.$axiosAdmin2.put(
						`/v3/api/review/report/${this.idReport}`,
						{
							state: 'F',
						}
					);
					this.historyBack();
				} catch (err) {
					console.error(err);
					alert('왼료처리실패! 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.review-report__cause--0 {
		margin-right: 12px;
	}

	.review-report__desc {
		margin-left: 12px;
		color: $font-blue;
		font-weight: bold;
	}

	.review-report-page {
		&__product-name {
			margin-left: 4px;
		}

		&__done-button {
			margin-left: 12px;
		}
	}
</style>
